export enum StaffBadgeType {
  FREELANCER_STAFF = 'freelancer-staff.svg',
}
